import { useLocation, useNavigate } from 'react-router-dom';
import { Path } from 'core/constants/path.constants';
import useTheme from 'shared/hooks/use-theme';
import { HeaderWrapper } from '../header-wrapper';

import './unauthenticated-header.scss';

export const UnauthenticatedHeader = () => {
  const navigate = useNavigate();
  const { pathname: path } = useLocation();
  const { channelTheme } = useTheme();

  const { logo, logoAlt } = channelTheme;

  const handleClickLogo = (): void => {
    if (path === Path.HOME) {
      document.location.reload();
      return;
    }
    navigate(Path.HOME);
  };

  return (
    <HeaderWrapper>
      <div className="unauthenticated-header__icons">
        <button type="button" className="unauthenticated-header__logo" onClick={handleClickLogo}>
          <img className="unauthenticated-header__image" src={logo} alt={logoAlt} />
        </button>
      </div>
    </HeaderWrapper>
  );
};
